import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from "react-redux";
import MaterialTable from 'material-table';
import GetAppIcon from '@material-ui/icons/GetApp';
import AddIcon from '@material-ui/icons/Add';
import { deleteUser, updateUser } from '../../redux/actions/userActions';
import CustomizedDialogs from '../../components/dialog';
import UserForm from '../../components/UserForm';
import { 
  Grid, 
  Paper, 
  TextField, 
  Button, 
  Typography, 
  Container, 
  Box, 
  InputAdornment, 
  IconButton, 
  Chip,
  Card,
  CardContent,
  alpha,
  AppBar,
  useTheme,
  useMediaQuery,
  MenuItem,
  Select,
  FormControl,
  InputLabel
} from '@material-ui/core';
import {
  Person,
  Group,
  Assignment,
  LocalShipping,
  Category,
  FolderOpen,
  LinearScale,
  ChangeHistory,
  Block,
  CheckCircle,
  Edit,
  Delete
} from '@material-ui/icons';
import CliniqueService from '../../services/CliniqueService';
import PropTypes from 'prop-types';
import * as Yup from 'yup';
import { toast } from "react-toastify";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import ListItemText from '@material-ui/core/ListItemText';
import PersonOutlineIcon from '@material-ui/icons/PersonOutline';
import Avatar from '@material-ui/core/Avatar';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import Fournisseur from '../../components/Fournisseur/Fournisseur';
import FPharmaceutique from '../../components/FPharmaceutique';
import Famille from '../../components/Famille.js';
import SousFamille from '../../components/SousFamille.js';
import Dosage from '../../components/Dosage';
import { Visibility, VisibilityOff } from '@material-ui/icons';

// Styles modernisés avec la même charte graphique
const useStyles = makeStyles((theme) => ({
  pageContainer: {
    minHeight: '100vh',
    backgroundColor: '#f8f9fa',
    paddingTop: theme.spacing(1),
  },
  appBar: {
    background: 'linear-gradient(135deg, #226D68 0%, #1a524e 100%)',
    borderRadius: '12px 12px 0 0',
    boxShadow: '0 4px 20px rgba(34, 109, 104, 0.3)',
    marginBottom: theme.spacing(1),
    marginTop: theme.spacing(1),
    marginLeft: 'auto',
    marginRight: 'auto',
    width: '85%',
  },
  tabs: {
    '& .MuiTab-root': {
      minWidth: 120,
      fontSize: '0.875rem',
      fontWeight: 500,
      textTransform: 'none',
      color: theme.palette.common.white,
      opacity: 0.8,
      '&.Mui-selected': {
        opacity: 1,
        color: theme.palette.common.white,
      },
      '&:hover': {
        opacity: 1,
        backgroundColor: 'rgba(242, 101, 34, 0.1)',
      },
    },
    '& .MuiTabs-indicator': {
      backgroundColor: '#f26522',
      height: 3,
    },
  },
  tabContainer: {
    padding: theme.spacing(4),
    backgroundColor: 'white',
    borderRadius: '0 0 16px 16px',
    boxShadow: '0 4px 20px rgba(34, 109, 104, 0.08)',
    minHeight: '500px',
    border: `1px solid #e0e0e0`,
    borderTop: 'none',
    marginLeft: 'auto',
    marginRight: 'auto',
    width: '85%',
  },
  title: {
    background: 'linear-gradient(135deg, #226D68 0%, #2a8c82 100%)',
    WebkitBackgroundClip: 'text',
    WebkitTextFillColor: 'transparent',
    fontWeight: 700,
    textAlign: 'center',
    marginBottom: theme.spacing(2), 
    marginTop: theme.spacing(1), 
    fontSize: '2rem', 
  },
  tableContainer: {
    borderRadius: 16,
    boxShadow: '0 8px 32px rgba(0,0,0,0.1)',
    overflow: 'hidden',
    margin: '10px auto',
    background: 'white',
  },
  roleCard: {
    background: 'linear-gradient(135deg, #226D68 0%, #2a8c82 100%)',
    color: 'white',
    borderRadius: 16,
    padding: theme.spacing(3),
    height: '100%',
    boxShadow: '0 8px 32px rgba(34, 109, 104, 0.3)',
  },
  listCard: {
    background: 'white',
    borderRadius: 16,
    padding: theme.spacing(2),
    height: '100%',
    boxShadow: '0 8px 32px rgba(0,0,0,0.1)',
    border: `1px solid ${alpha('#226D68', 0.1)}`,
  },
  roleChip: {
    fontWeight: 'bold',
    color: 'white',
    '&.admin': {
      background: 'linear-gradient(135deg, #2e7d32 0%, #4caf50 100%)',
    },
    '&.gerant': {
      background: 'linear-gradient(135deg, #ed6c02 0%, #ff9800 100%)',
    },
    '&.other': {
      background: 'linear-gradient(135deg, #9c27b0 0%, #e91e63 100%)',
    },
  },
  passwordField: {
    '& input': {
      fontFamily: '"Courier New", monospace',
      letterSpacing: '1px',
    },
  },
  submitButton: {
    background: 'linear-gradient(135deg, #f26522 0%, #ff8c42 100%)',
    color: 'white',
    fontWeight: 600,
    padding: theme.spacing(1.2),
    borderRadius: 12,
    boxShadow: '0 4px 20px rgba(242, 101, 34, 0.3)',
    '&:hover': {
      background: 'linear-gradient(135deg, #e55a1a 0%, #ff7b2e 100%)',
      transform: 'translateY(-2px)',
      boxShadow: '0 6px 25px rgba(242, 101, 34, 0.4)',
    },
    transition: 'all 0.3s ease',
  },
  roleItem: {
    borderRadius: 12,
    marginBottom: theme.spacing(1),
    border: `1px solid ${alpha('#226D68', 0.1)}`,
    transition: 'all 0.3s ease',
    '&:hover': {
      background: alpha('#226D68', 0.05),
      transform: 'translateX(8px)',
      boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
    },
  },
  addButton: {
    background: 'linear-gradient(135deg, #226D68 0%, #2a8c82 100%)',
    color: 'white',
    borderRadius: 12,
    padding: theme.spacing(1, 2),
    fontWeight: 600,
    boxShadow: '0 4px 20px rgba(34, 109, 104, 0.3)',
    '&:hover': {
      background: 'linear-gradient(135deg, #1a5a55 0%, #22746d 100%)',
      transform: 'translateY(-2px)',
    },
  },
  statChip: {
    borderRadius: '20px',
    fontWeight: 600,
    margin: theme.spacing(0.5),
    fontSize: '0.75rem',
  },
  statusChip: {
    fontWeight: 600,
    '&.active': {
      backgroundColor: '#4caf50',
      color: 'white',
    },
    '&.inactive': {
      backgroundColor: '#f44336',
      color: 'white',
    },
  },
  actionButton: {
    minWidth: 'auto',
    padding: theme.spacing(0.5),
    margin: theme.spacing(0, 0.5),
    '&.activate': {
      color: '#4caf50',
      '&:hover': {
        backgroundColor: 'rgba(76, 175, 80, 0.1)',
      },
    },
    '&.deactivate': {
      color: '#f44336',
      '&:hover': {
        backgroundColor: 'rgba(244, 67, 54, 0.1)',
      },
    },
    '&.edit': {
      color: '#226D68',
      '&:hover': {
        backgroundColor: 'rgba(34, 109, 104, 0.1)',
      },
    },
    '&.delete': {
      color: '#ff9800',
      '&:hover': {
        backgroundColor: 'rgba(255, 152, 0, 0.1)',
      },
    },
  },
}));

const StyledTabs = withStyles({
  indicator: {
    backgroundColor: '#f26522',
    height: 3,
    borderRadius: 2,
  },
})(Tabs);

const StyledTab = withStyles((theme) => ({
  root: {
    textTransform: 'none',
    fontWeight: 600,
    fontSize: '0.9rem',
    marginRight: theme.spacing(1),
    color: 'rgba(255, 255, 255, 0.7)',
    '&$selected': {
      color: '#fff',
    },
    '&:focus': {
      opacity: 1,
    },
  },
  selected: {},
}))((props) => <Tab disableRipple {...props} />);

const TabContainer = ({ children, value, index, ...other }) => {
  const classes = useStyles();
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`tabpanel-${index}`}
      aria-labelledby={`tab-${index}`}
      className={classes.tabContainer}
      {...other}
    >
      {value === index && children}
    </div>
  );
};

TabContainer.propTypes = {
  children: PropTypes.node.isRequired,
  value: PropTypes.number.isRequired,
  index: PropTypes.number.isRequired,
};

const Users = () => {
  const [value, setValue] = useState(0);
  const [roles, setRoles] = useState([]);
  const [users, setUsers] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);
  const [showPasswords, setShowPasswords] = useState({});
  const [filterStatus, setFilterStatus] = useState('all'); // 'all', 'active', 'inactive'
  const classes = useStyles();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const dispatch = useDispatch();
  const user = useSelector((state) => state.auth);
  const speudo = user?.nom; 

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  useEffect(() => {
    const fetchData = async () => {
      await CliniqueService.getAllUsers()
        .then((response) => {
          setIsLoading(false);
          setUsers(response.data)
        })
        .catch(e => {
          setIsLoading(false);
          setIsError(true);
          console.log(e);
        });

      await CliniqueService.getRoles()
        .then((response) => {
          setRoles(response.data)
        })
        .catch(e => {
          console.log(e);
        });
    }
    fetchData()
  }, [])

  const refreshUsers = async () => {
    await CliniqueService.getAllUsers()
      .then((response) => {
        setIsLoading(false);
        setUsers(response.data)
      })
      .catch(e => {
        setIsLoading(false);
        setIsError(true);
        console.log(e);
      });
    await CliniqueService.getRoles()
      .then((response) => {
        setRoles(response.data)
      })
      .catch(e => {
        console.log(e);
      });
  }

  // Fonction pour changer le statut d'un utilisateur
  const toggleUserStatus = async (userId, currentStatus, speudoCible) => {
    // Vérifie si c'est le même pseudo que celui connecté
    if (speudoCible === speudo) {
      toast.warn("Vous ne pouvez pas vous désactiver vous-même !", {
        position: toast.POSITION.BOTTOM_RIGHT,
      });
      return;
    }
  
    try {
      const newStatus = currentStatus ? 0 : 1;
      await CliniqueService.updateUserStatus(userId, { actif: newStatus });
  
      toast.success(`Utilisateur ${newStatus ? 'activé' : 'désactivé'} avec succès`, {
        position: toast.POSITION.BOTTOM_RIGHT,
      });
  
      refreshUsers();
    } catch (error) {
      console.error('Erreur lors du changement de statut:', error);
      toast.error("Erreur lors du changement de statut", {
        position: toast.POSITION.BOTTOM_RIGHT,
      });
    }
  };
  

  // Filtrer les utilisateurs selon le statut
  const filteredUsers = users.filter(user => {
    switch (filterStatus) {
      case 'active':
        return user.actif === 1;
      case 'inactive':
        return user.actif === 0;
      default:
        return true;
    }
  });

  const initialValues = {
    rol: '',
  }

  const validationSchema = Yup.object().shape({
    rol: Yup.string().required("Required"),
  })

  const onSubmit = (values, props) => {
    var user = {
      "rol": values.rol.trim(),
    }
    
    CliniqueService.createRole(user)
      .then(response => {
        toast("Rôle ajouté avec succès", {
          position: toast.POSITION.BOTTOM_RIGHT,
        });
        refreshUsers()
        props.resetForm()
      })
      .catch((error) => {
        console.log(error.response);
        toast.error(error.response?.data, {
          position: toast.POSITION.BOTTOM_RIGHT,
        });
      });
  }

  const togglePasswordVisibility = (userId) => {
    setShowPasswords(prev => ({
      ...prev,
      [userId]: !prev[userId]
    }));
  };

  const maskPassword = (password) => {
    return '•'.repeat(password?.length || 8);
  };

  const getRoleChipClass = (role) => {
    switch (role?.toLowerCase()) {
      case 'admin': return 'admin';
      case 'gerant': return 'gerant';
      default: return 'other';
    }
  };

  // Statistiques
  const activeUsers = users.filter(user => user.actif === 1).length;
  const inactiveUsers = users.filter(user => user.actif === 0).length;

  // Configuration des colonnes avec UN SEUL CHAMP ACTIONS
  const userColumns = [
    { 
      title: "Nom", 
      field: "nom", 
      sorting: false, 
      filtering: true, 
      headerStyle: { 
        background: 'linear-gradient(135deg, #226D68 0%, #2a8c82 100%)',
        color: "#fff",
        fontSize: '14px',
        fontWeight: 600,
      },
      cellStyle: {
        fontSize: '14px',
      }
    },
    { 
      title: "Prénom", 
      field: "prenom", 
      filterPlaceholder: "Filtrer",
      headerStyle: { 
        background: 'linear-gradient(135deg, #226D68 0%, #2a8c82 100%)',
        color: "#fff",
        fontSize: '14px',
        fontWeight: 600,
      } 
    },
    { 
      title: "PSEUDO", 
      field: "speudo", 
      align: "center",
      headerStyle: { 
        background: 'linear-gradient(135deg, #226D68 0%, #2a8c82 100%)',
        color: "#fff",
        fontSize: '14px',
        fontWeight: 600,
      } 
    },
    { 
      title: "MOT DE PASSE", 
      field: "passwd", 
      align: "center",
      headerStyle: { 
        background: 'linear-gradient(135deg, #226D68 0%, #2a8c82 100%)',
        color: "#fff",
        fontSize: '14px',
        fontWeight: 600,
      },
      render: rowData => (
        <Box display="flex" alignItems="center" justifyContent="center">
          <TextField
            type={showPasswords[rowData.id] ? "text" : "password"}
            value={showPasswords[rowData.id] ? rowData.passwd : maskPassword(rowData.passwd)}
            variant="outlined"
            size="small"
            className={classes.passwordField}
            InputProps={{
              readOnly: true,
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    size="small"
                    onClick={() => togglePasswordVisibility(rowData.id)}
                    edge="end"
                  >
                    {showPasswords[rowData.id] ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              ),
            }}
            style={{ width: 150 }}
          />
        </Box>
      ),
      editComponent: props => (
        <TextField
          type="password"
          value={props.value}
          onChange={e => props.onChange(e.target.value)}
        />
      )
    },
    {
      title: "Rôle",
      field: "rol",
      headerStyle: { 
        background: 'linear-gradient(135deg, #226D68 0%, #2a8c82 100%)',
        color: "#fff",
        fontSize: '14px',
        fontWeight: 600,
      },
      render: (rowData) => (
        <Chip
          label={rowData.rol?.toUpperCase()}
          className={`${classes.roleChip} ${getRoleChipClass(rowData.rol)}`}
          size="small"
        />
      ),
      lookup: roles.reduce((acc, role) => {
        acc[role.rol] = role.rol.toUpperCase();
        return acc;
      }, {}),
    },
    {
      title: "STATUT",
      field: "actif",
      headerStyle: { 
        background: 'linear-gradient(135deg, #226D68 0%, #2a8c82 100%)',
        color: "#fff",
        fontSize: '14px',
        fontWeight: 600,
      },
      render: (rowData) => (
        <Chip
          icon={rowData.actif ? <CheckCircle /> : <Block />}
          label={rowData.actif ? "ACTIF" : "INACTIF"}
          className={`${classes.statusChip} ${rowData.actif ? 'active' : 'inactive'}`}
          size="small"
        />
      ),
      lookup: {
        1: "ACTIF",
        0: "INACTIF"
      },
    }
  ];

  // Configuration des tabs avec icônes comme dans le composant Client
  const tabsConfig = [
    { 
      label: "Utilisateurs", 
      icon: <Person />, 
      visible: true, 
      component: (
        <Box>
          <Box display="flex" justifyContent="space-between" alignItems="center" mb={2} flexWrap="wrap" gap={2}>
            <CustomizedDialogs 
              title="Nouvel utilisateur" 
              boutonTitle="Ajouter un utilisateur" 
              refresh={() => refreshUsers()}
            >
              <UserForm />
            </CustomizedDialogs>

            {/* Filtre de statut */}
            <FormControl variant="outlined" size="small" style={{ minWidth: 150 }}>
              <InputLabel>Statut</InputLabel>
              <Select
                value={filterStatus}
                onChange={(e) => setFilterStatus(e.target.value)}
                label="Statut"
              >
                <MenuItem value="all">Tous les utilisateurs</MenuItem>
                <MenuItem value="active">Utilisateurs actifs</MenuItem>
                <MenuItem value="inactive">Utilisateurs désactivés</MenuItem>
              </Select>
            </FormControl>
          </Box>
          
          <div className={classes.tableContainer}>
            <MaterialTable 
              columns={userColumns}
              data={filteredUsers}
              editable={{
                onRowUpdate: (newRow, oldRow) => new Promise((resolve, reject) => {
                  dispatch(updateUser(newRow, oldRow.id))
                  refreshUsers()
                  setTimeout(() => resolve(), 500)
                }),
                onRowDelete: (selectedRow) => new Promise((resolve, reject) => {
                  dispatch(deleteUser(selectedRow.id))
                  refreshUsers()
                  setTimeout(() => resolve(), 1000)
                })
              }}
              actions={[
                {
                  icon: () => <GetAppIcon />,
                  tooltip: "Exporter les données",
                  onClick: (e, data) => console.log(data),
                },
                {
                  icon: (rowData) => rowData.actif ? <Block style={{ color: '#f44336' }} /> : 
                  <CheckCircle style={{ color: '#4caf50' }} />,
                  tooltip: (rowData) => rowData.actif ? "Désactiver l'utilisateur" : "Activer l'utilisateur",
                  onClick: (event, rowData) => toggleUserStatus(rowData.id, rowData.actif, rowData.speudo)
                }
              ]}
              options={{
                sorting: true, 
                search: true,
                searchFieldAlignment: "right", 
                searchAutoFocus: true, 
                searchFieldVariant: "outlined",
                filtering: true, 
                paging: true, 
                pageSizeOptions: [5, 10, 20, 50, 100], 
                pageSize: 10,
                paginationType: "stepped", 
                showFirstLastPageButtons: true, 
                paginationPosition: "bottom", 
                exportButton: true,
                exportAllData: true, 
                exportFileName: "Utilisateurs_Data", 
                addRowPosition: "first", 
                actionsColumnIndex: -1, 
                selection: false,
                showSelectAllCheckbox: false, 
                showTextRowsSelected: false,
                columnsButton: true,
                rowStyle: (data, index) => index % 2 === 0 ? { background: "#f8f9fa" } : null,
                headerStyle: { 
                  background: 'linear-gradient(135deg, #226D68 0%, #2a8c82 100%)',
                  color: "#fff",
                  fontSize: '14px',
                  fontWeight: 600,
                },
              }}
              title={
                <Box>
                  <Typography variant="h6" style={{ color: '#226D68', fontWeight: 600 }}>
                    Liste des Utilisateurs
                  </Typography>
                  <Typography variant="body2" color="textSecondary">
                    {filteredUsers.length} utilisateur(s) - {activeUsers} actif(s), {inactiveUsers} inactif(s)
                  </Typography>
                </Box>
              }
              icons={{ Add: () => <AddIcon /> }} 
            />
          </div>
        </Box>
      ) 
    },
    // ... le reste de vos tabs reste inchangé
    { 
      label: "Rôles", 
      icon: <Group />, 
      visible: true, 
      component: (
        <Grid container spacing={2}> 
          <Grid item xs={12} md={5}>
            <Card className={classes.roleCard}>
              <CardContent>
                <Box textAlign="center" mb={2}>
                  <PersonOutlineIcon style={{ fontSize: 40, marginBottom: 12 }} />
                  <Typography variant="h5" gutterBottom style={{ fontWeight: 600 }}>
                    Ajouter un Rôle
                  </Typography>
                  <Typography variant="body2" style={{ opacity: 0.9 }}>
                    Créez un nouveau rôle pour votre système
                  </Typography>
                </Box>
                
                <Formik initialValues={initialValues} validationSchema={validationSchema} onSubmit={onSubmit}>
                  {(props) => (
                    <Form noValidate>
                      <Grid container spacing={2}>
                        <Grid item xs={12}>
                          <Field 
                            as={TextField}
                            name='rol' 
                            label='Nom du rôle' 
                            fullWidth 
                            variant="outlined"
                            InputProps={{
                              style: { 
                                background: 'rgba(255,255,255,0.9)',
                                borderRadius: 8
                              }
                            }}
                            InputLabelProps={{
                              style: { color: 'white' }
                            }}
                            error={props.errors.rol && props.touched.rol}
                            helperText={<ErrorMessage name='rol' />} 
                            required 
                          />
                        </Grid>
                        <Grid item xs={12}>
                          <Button 
                            type='submit' 
                            className={classes.submitButton} 
                            variant='contained' 
                            fullWidth
                            size="large"
                          >
                            Créer le Rôle
                          </Button>
                        </Grid>
                      </Grid>
                    </Form>
                  )}
                </Formik>
              </CardContent>
            </Card>
          </Grid>

          <Grid item xs={12} md={7}>
            <Card className={classes.listCard}>
              <CardContent>
                <Box mb={2}>
                  <Typography variant="h5" gutterBottom style={{ color: '#226D68', fontWeight: 600 }}>
                    Liste des Rôles
                  </Typography>
                  <Typography variant="body2" color="textSecondary">
                    {roles.length} rôle(s) configuré(s)
                  </Typography>
                </Box>
                
                <List style={{ maxHeight: 400, overflow: 'auto' }}>
                  {roles.map((item, index) => (
                    <ListItem key={index} className={classes.roleItem}>
                      <ListItemAvatar>
                        <Avatar style={{ 
                          background: 'linear-gradient(135deg, #226D68 0%, #2a8c82 100%)',
                          boxShadow: '0 4px 12px rgba(34, 109, 104, 0.3)'
                        }}>
                          <PersonOutlineIcon style={{ color: 'white' }} />
                        </Avatar>
                      </ListItemAvatar>
                      <ListItemText 
                        primary={
                          <Typography variant="body1" style={{ fontWeight: 600, color: '#226D68' }}>
                            {item.rol}
                          </Typography>
                        }
                        secondary={`Créé le ${new Date().toLocaleDateString()}`}
                      />
                      <ListItemSecondaryAction>
                        <IconButton edge="end" size="small" style={{ marginRight: 8 }}>
                          <EditIcon fontSize="small" />
                        </IconButton>
                        <IconButton edge="end" size="small">
                          <DeleteIcon fontSize="small" />
                        </IconButton>
                      </ListItemSecondaryAction>
                    </ListItem>
                  ))}
                  
                  {roles.length === 0 && (
                    <Box textAlign="center" py={3}>
                      <PersonOutlineIcon style={{ fontSize: 40, color: '#ccc', marginBottom: 12 }} />
                      <Typography variant="h6" color="textSecondary" gutterBottom>
                        Aucun rôle créé
                      </Typography>
                      <Typography variant="body2" color="textSecondary">
                        Commencez par ajouter votre premier rôle
                      </Typography>
                    </Box>
                  )}
                </List>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      ) 
    },
    { 
      label: "Fournisseurs", 
      icon: <LocalShipping />, 
      visible: true, 
      component: <Fournisseur /> 
    },
    { 
      label: "Formes", 
      icon: <ChangeHistory />, 
      visible: true, 
      component: <FPharmaceutique /> 
    },
    { 
      label: "Dosages", 
      icon: <LinearScale />, 
      visible: true, 
      component: <Dosage /> 
    },
    { 
      label: "Familles", 
      icon: <Category />, 
      visible: true, 
      component: <Famille /> 
    },
    { 
      label: "Sous-Familles", 
      icon: <FolderOpen />, 
      visible: true, 
      component: <SousFamille /> 
    },
  ];

  const visibleTabs = tabsConfig.filter(tab => tab.visible);

  if (isLoading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="100vh">
        <Typography variant="h6">Chargement...</Typography>
      </Box>
    );
  }

  return (
    <div className={classes.pageContainer}>
      <Container maxWidth="xl">
        {/* Titre centré exactement comme dans l'exemple */}
        <Typography variant="h3" className={classes.title}>
          Gestion des Utilisateurs
        </Typography>

        {/* Navigation par onglets */}
        <Paper elevation={0}>
          <AppBar position="static" className={classes.appBar}>
            <StyledTabs 
              value={value} 
              onChange={handleChange}
              className={classes.tabs}
              variant={isMobile ? "scrollable" : "standard"}
              scrollButtons="auto"
              centered
            >
              {visibleTabs.map((tab, index) => (
                <StyledTab
                  key={index}
                  icon={tab.icon}
                  label={isMobile ? null : tab.label}
                  aria-label={tab.label}
                />
              ))}
            </StyledTabs>
          </AppBar>

          {/* Contenu des onglets */}
          {visibleTabs.map((tab, index) => (
            <TabContainer key={index} value={value} index={index}>
              {tab.component}
            </TabContainer>
          ))}
        </Paper>

        {/* Indicateurs de statut en bas de page - MIS À JOUR */}
        <Box mt={3} display="flex" justifyContent="center" flexWrap="wrap">
          <Chip
            icon={<Person style={{ color: '#226D68' }} />}
            label={`${users.length} utilisateurs`}
            className={classes.statChip}
            style={{ 
              backgroundColor: '#E8F5E8', 
              color: '#226D68',
              border: '1px solid #226D68'
            }}
          />
          <Chip
            icon={<CheckCircle style={{ color: '#4caf50' }} />}
            label={`${activeUsers} actifs`}
            className={classes.statChip}
            style={{ 
              backgroundColor: '#E8F5E8', 
              color: '#4caf50',
              border: '1px solid #4caf50'
            }}
          />
          <Chip
            icon={<Block style={{ color: '#f44336' }} />}
            label={`${inactiveUsers} inactifs`}
            className={classes.statChip}
            style={{ 
              backgroundColor: '#FFEBEE', 
              color: '#f44336',
              border: '1px solid #f44336'
            }}
          />
          <Chip
            icon={<Group style={{ color: '#f26522' }} />}
            label={`${roles.length} rôles`}
            className={classes.statChip}
            style={{ 
              backgroundColor: '#FFF3E0', 
              color: '#f26522',
              border: '1px solid #f26522'
            }}
          />
        </Box>

        {/* Footer décoratif */}
        <Box mt={4} textAlign="center">
          <Typography variant="body2" color="textSecondary">
            Système de gestion utilisateur • 
            <span style={{ color: '#226D68', fontWeight: 600 }}> Vert</span>
            <span style={{ color: '#f26522', fontWeight: 600 }}> Orange</span>
            {' '}Theme
          </Typography>
        </Box>
      </Container>
    </div>
  );
}

export default Users;